var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"header__cart-title",attrs:{"href":_vm.cart.checkoutUrl}},[(_vm.cart.quantity>0)?_c('div',{staticClass:"header__cart-label"},[_vm._v(_vm._s(_vm.cart.checkoutName)+" "+_vm._s(_vm.cart.quantity))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }